import request from '@/utils/request'

export function sendSmsCode (data) {
  return request({
    url: '/api/man/send/code',
    method: 'get',
    params: data
  })
}

export function login (data) {
  return request({
    url: '/api/man/login/mobile',
    method: 'get',
    params: data
  })
}

export function loginPass (data) {
  return request({
    url: '/api/man-login-pass',
    method: 'get',
    params: data
  })
}

export function logout () {
  return request({
    url: '/api/man/logout',
    method: 'get',
    params: {}
  })
}

export function getUserInfoByWechatCode(data) {
  return request({
    url: '/api/wechat/get-user-info-by-code',
    method: 'get',
    params: data
  })
}

export function sendRegisterCode(data) {
  return request({
    url: '/api/wechat/send-register-code',
    method: 'get',
    params: data,
  })
}

export function bindMobile(data) {
  return request({
    url: '/api/wechat/bind-mobile',
    method: 'post',
    data: data
  })
}

/**
 * 获取工人信息
 * @returns {*}
 */
export function getManInfo() {
  return request({
    url: '/api/an/worker/getWorkerInfo',
    method: 'get',
  })
}

export function updateManInfo(data) {
  return request({
    url: '/api/an/worker/createOrUpdateCertificate',
    method: 'post',
    data: data
  })
}

export function updateAnnexManInfo(annexId, data) {
  return request({
    url: '/api/man-update-base/' + annexId,
    method: 'put',
    data: data
  })
}

export function getCountNum() {
  return request({
    url: '/api/an/worker/getCountNum',
    method: 'get'
  })
}

export function getWorkerInfo() {
  return request({
    url: '/api/an/worker/getWorkerInfo',
    method: 'get'
  })
}

export function postContract(data) {
  return request({
    url: '/api/an/workerContract',
    method: 'post',
    data: data
  })
}

/**
 * @param data
 * @returns {*}
 */
export function workerDeleteWorkerInfoReport(data) {
  return request({
    url: '/api/an/worker/workerDeleteWorkerInfoReport',
    method: 'post',
    data: data
  })
}

export function workerSubmitConstructionReport(data) {
  return request({
    url: '/api/an/worker/workerSubmitConstructionReport',
    method: 'post',
    data: data
  })
}

export function getCooperateWorkerList(data) {
  return request({
    url: '/api/an/worker/getCooperateWorkerList',
    method: 'get',
    params: data
  })
}

export function createOrUpdateWorkerReport(data) {
  return request({
    url: '/api/an/worker/workerCreateOrUpdateWorkerInfoReportNew',
    method: 'post',
    data: data
  })
}

export function getWorkerInfoReportNew(data) {
  return request({
    url: '/api/an/worker/getWorkerInfoReportNew',
    method: 'get',
    params: data
  })
}

export function workerSubmitConstructionReportNew(data) {
  return request({
    url: '/api/an/worker/workerSubmitConstructionReportNew',
    method: 'post',
    data: data
  })
}

export function updateWorkerName(data) {
  return request({
    url: '/api/an/worker/updateWorkerInfo',
    method: 'post',
    data
  })
}

export function getBaseInfo() {
  return request({
    url: '/api/an/worker/getMyBaseInfo',
    method: 'get'
  })
}

export function postNewContract(data) {
  return request({
    url: '/api/v2/worker/personnel/add_new_contract',
    method: 'post',
    data: data
  })
}

/**
 * 获取培训模板
 * @param {number} id 培训模板ID
 * @returns {*}
 */
export function getTrainingTemplate(id) {
  return request({
    url: `/api/v2/worker/personnel/training-template/${id}`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js